import type { FC, PropsWithChildren } from 'react';

import { Loading } from '../components';
import { ContentsProvider } from '../contexts';
import { useContentsQuery } from '../hooks';

export const ContentsContainer: FC<PropsWithChildren> = ({ children }) => {
  const { data: contentsData } = useContentsQuery();
  if (!contentsData) {
    return <Loading />;
  }

  const { contents } = contentsData;

  return <ContentsProvider value={contents ?? {}}>{children}</ContentsProvider>;
};
